import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ConvertToString, { getClassName, getValue } from "../../../../components/Converter";
import ConvertMeasurement from "../../../../components/Math/Conversion/ConvertMeasurement";
import { ImperialUnits, MetricUnits } from "../../../../components/Math/Units/AllUnits";
import { useGetBohrkronenQuery } from "../../../../services/API/titanApi";
import {
  selectHoleSize,
  selectedCarryingElement,
  setHoleSize,
  setHoleSizeCustom,
} from "../../../../store/slices/aashtoSlice";
import { selectIsMetric } from "../../../../store/slices/settingsSlice";
import { NumericFormat as NumberFormat } from "react-number-format";
import { decimalSeparator } from "../../../../i18n";
import { thousandSeparator } from "../../../../i18n";

function DrillBitDiameterDropDown() {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const { data: bohrkronen } = useGetBohrkronenQuery();
  const carryingElement = useSelector(selectedCarryingElement);
  const holeSize = useSelector(selectHoleSize);
  const holeSizeIsCustom = useSelector((state) => state.aashto.holeSizeIsCustom);

  const isMetric = useSelector(selectIsMetric);

  const [selectedValue, setSelectedValue] = useState(holeSizeIsCustom ? "custom" : holeSize.metric);

  const handleChange = (e) => {
    let targetvalue = e.target.value;

    if (targetvalue === "custom") {
      setSelectedValue("custom");
      return;
    }

    setSelectedValue(Number(targetvalue));
    dispatch(
      setHoleSize({
        value: Number(targetvalue),
        unit: MetricUnits.Millimetre,
      })
    );
  };

  function findArrayElement(title) {
    return bohrkronen?.find((element) => {
      return element.tragglied_name == title;
    });
  }

  let unique_standard;
  let unique_adapter;
  function prepareOptions(bohrkronenElement) {
    let standard = [];
    let mitAdapter = [];

    // standard
    // bindiger_boden
    bohrkronenElement?.bindiger_boden?.standard?.forEach((element) => {
      standard.push(element);
    });
    // nichtbindiger_boden
    bohrkronenElement?.nichtbindiger_boden?.standard?.forEach((element) => {
      standard.push(element);
    });
    // fels
    bohrkronenElement?.fels?.standard?.forEach((element) => {
      standard.push(element);
    });

    // adapter
    // bindiger_boden
    bohrkronenElement?.bindiger_boden?.adapter?.forEach((element) => {
      mitAdapter.push(element);
    });
    // nichtbindiger_boden
    bohrkronenElement?.nichtbindiger_boden?.adapter?.forEach((element) => {
      mitAdapter.push(element);
    });
    // fels
    bohrkronenElement?.fels?.adapter?.forEach((element) => {
      mitAdapter.push(element);
    });

    unique_standard = [...new Set(new Float64Array(standard).sort())];
    unique_adapter = [...new Set(new Float64Array(mitAdapter).sort())];
  }

  function renderOptionGroup(array, indexIncrement, color) {
    return array.map((element, index) => {
      let displayValue = element;

      if (!isMetric) {
        displayValue = ConvertMeasurement({
          userInput: element,
          from: MetricUnits.Millimetre,
          to: ImperialUnits.Inch,
        });
      }
      return (
        <option
          className={`${color}`}
          key={(index + indexIncrement) * 10}
          value={element}
          //selected={isSelectedBohrkrone(element)}
        >
          {ConvertToString(displayValue, isMetric ? 0 : 2)}
        </option>
      );
    });
  }

  useEffect(() => {
    prepareOptions(drillBitElement);
  }, [bohrkronen]);

  const drillBitElement = findArrayElement(carryingElement?.name);
  const unit = isMetric ? MetricUnits.Millimetre : ImperialUnits.Inch;
  prepareOptions(drillBitElement);
  return (
    <div>
      <select
        className={getClassName(holeSize.current != 0)}
        onChange={handleChange}
        value={selectedValue ?? 0}
      >
        <option value={0}>{t("select")}</option>

        <optgroup label={t("drillBits.standard")} key={1}>
          {renderOptionGroup(unique_standard, 1, "green")}
        </optgroup>
        <optgroup label={t("drillBits.withAdapter")} key={2}>
          {renderOptionGroup(unique_adapter, 2, "red")}
        </optgroup>
        <option value={"custom"}>{t("custom")}</option>
      </select>

      {selectedValue === "custom" ? (
        <NumberFormat
          className={getClassName(holeSize.current)}
          value={getValue(holeSize.current)}
          decimalSeparator={decimalSeparator()}
          thousandSeparator={thousandSeparator()}
          decimalScale={2}
          displayType="input"
          type="text"
          onValueChange={(values, sourceInfo) => {
            if (sourceInfo?.event?._reactName === "onChange") {
              dispatch(
                setHoleSizeCustom({
                  value: values.floatValue,
                  unit: unit,
                })
              );
            }
          }}
        />
      ) : null}
    </div>
  );
}

export default DrillBitDiameterDropDown;
